import React, { useMemo } from 'react';
import QuestionResults from '../QuestionResults';
import { useAssessmentReviewContext } from '../AssessmentReviewContext';
import { constructAdditionalElementKey } from 'js/engines/CapabilitiesAssessment/utils';
import { withParentSize } from '@visx/responsive';

function AdditionalElementQuestionResults({
  page,
  capabilityElement,
  element,
  parentWidth,
}) {
  const { questionMap } = useAssessmentReviewContext();

  const question = useMemo(() => {
    const questionKey = constructAdditionalElementKey(
      page,
      capabilityElement,
      element
    );

    return questionMap[questionKey];
  }, [questionMap, page, capabilityElement, element]);

  return <QuestionResults question={question} width={parentWidth} />;
}

export default withParentSize(AdditionalElementQuestionResults);
